import React, { useEffect, useState } from "react";

interface LoadingScreenProps {
  children: React.ReactNode;
}

// This screen prevents a flash of unstyled content before the app is ready
const LoadingScreen: React.FC<LoadingScreenProps> = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Hide loading screen after a short delay to ensure CSS is loaded
    const timer = setTimeout(() => {
      setIsLoading(false);
      // Add class to body to hide the HTML loading screen
      document.body.classList.add("app-ready");
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return (
      <div className="loading-screen flex justify-center items-center h-[100dvh] bg-[#e3f2fd]">
        <div className="loading-spinner w-10 h-10 border-4 border-[#e3f2fd] border-t-[#1976d2] rounded-full animate-spin"></div>
      </div>
    );
  }

  return <>{children}</>;
};

export default LoadingScreen;
